import React, { useState } from 'react';
import { useRouter } from 'next/router';
import Status from 'views/Questions/components/Status';
import { ChangeQuestionPanelProps } from 'views/Questions/components/ChangeQuestionPanel/ChangeQuestionPanel.types';
import Button from 'components/Button';
import deleteQuestion from 'views/Questions/api/deleteQuestion';
import showNotification from 'utils/showNotification';
import styles from './ChangeQuestionPanel.module.css';

const ChangeQuestionPanel = ({
  type,
  questionSlug,
  editQuestion,
}: ChangeQuestionPanelProps) => {
  const [showConfirmRemove, setShowConfirmRemove] = useState(false);
  const router = useRouter();

  const deleteQuestionHandler = async () => {
    const delResponse = await deleteQuestion(questionSlug);
    if (delResponse && delResponse.success) {
      return await router.push('/');
    }
    showNotification('error', 'Произошла ошибка');
  };

  return (
    <div className={styles.wrapper}>
      {!showConfirmRemove && (
        <>
          <Status type={type} />
          <div className={styles.controls}>
            <Button
              className={styles.controls__change}
              type="transparent"
              text="Изменить вопрос"
              onClick={() => editQuestion(true)}
            />
            <Button
              className={styles.controls__remove}
              type="transparent"
              text="Удалить"
              onClick={() => setShowConfirmRemove(true)}
            />
          </div>
        </>
      )}
      {showConfirmRemove && (
        <>
          <span className={styles.remove_text}>Удалить вопрос?</span>
          <div className={styles.controls}>
            <Button
              className={styles.remove_btn}
              text="Да, удалить"
              onClick={() => deleteQuestionHandler()}
            />
            <Button
              className={styles.remove_cancel}
              text="Отмена"
              onClick={() => setShowConfirmRemove(false)}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ChangeQuestionPanel;
